<rt-dialog-body layout layout-justify-center>
  <div layout-vertical layout-align-items-center margin-small>
    <div class="img-wrap" layout-centered margin-top margin-bottom-large>
      <img [src]="imageSrc" alt="illustration" />
    </div>
    <rt-heading variant="heading large-xx" margin-bottom-small-x>
      {{ title }}
    </rt-heading>
    <p margin-bottom text-center>
      {{ description }}
    </p>
    <rt-admins-avatars
      [admins]="admins"
      [editable]="false"
      [stacked]="true"
      [limit]="ADMINS_LIMIT"
      avatarShape="oval"
    ></rt-admins-avatars>
  </div>
</rt-dialog-body>
